import classNames from 'classnames';
import React from "react";
import {Link, useLocation} from "react-router-dom";
import Brand from "../brand/Brand.js";
import styles from './AdminSidebar.module.css'


const AdminSidebar = ({ navigation }) => {
    const location = useLocation();
    const selectedTab = navigation.find(item => location.pathname.includes(item.url))

    // check if selected and use styles and classes to hide text
    return (
        <nav>
            <ul className={styles.sidebar}>
                <Brand size="small" className={styles.logo}/>
                {navigation.map(item => (
                    <NavbarItem
                        key={item.label}
                        label={item.label}
                        url={item.url}
                        icon={item.icon}
                        selected={item === selectedTab}
                    />
                ))}
            </ul>
            {selectedTab && (
                <ul className={styles.secondaryBar}>
                    {selectedTab.items.map(item => (
                        <SecondaryNavbarItem
                            key={item.label}
                            label={item.label}
                            url={selectedTab.url + item.path}
                            selected={location.pathname.includes(selectedTab.url + item.path)}
                        />
                    ))}
                </ul>
            )}
        </nav>
    )
}

const NavbarItem = ({ label, url, icon, selected }) => {

    return (
        <li>
            <Link to={url} className={classNames(styles.item, { [styles.selected]: selected})}>
                {icon}
                <span>{label}</span>
            </Link>
        </li>
    )

}

const SecondaryNavbarItem = ({ label, url, selected}) => {
    return (
        <li>
            <Link to={url} className={classNames(styles.item, { [styles.selected]: selected})}>
                {label}
            </Link>
        </li>
    )
}


export default AdminSidebar;